import { render, staticRenderFns } from "./picList.vue?vue&type=template&id=1bbf384d&scoped=true&"
import script from "./picList.vue?vue&type=script&lang=ts&"
export * from "./picList.vue?vue&type=script&lang=ts&"
import style0 from "./picList.vue?vue&type=style&index=0&id=1bbf384d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf384d",
  null
  
)

export default component.exports